export default "__VITE_ASSET__948a01d7__"